import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import { SuiteCategorySource } from "../v3/_common/machines/ecommerce-machine/e-commerce-machine-context"

const separator = "-"
const S = "S"
const Q = "Q"

const shortSource: Record<SuiteCategorySource, string> = {
    standard: S,
    quote: Q,
}
const longSource: Record<string, SuiteCategorySource> = {
    [S]: "standard",
    [Q]: "quote",
}

type SuiteCategory = { suiteCategory: string; source: SuiteCategorySource }
export const encodeSuite = (suite: SuiteCategory) => `${shortSource[suite.source]}${separator}${suite.suiteCategory}`

export const decodeSuite = (encodedSuite?: string | null): O.Option<SuiteCategory> =>
    F.pipe(
        O.fromNullable(encodedSuite),
        O.map((x) => x.split(separator)),
        O.chain(O.fromPredicate((x) => x.length === 1 || x.length === 2)),
        O.chain((x) =>
            x.length === 1
                ? O.some({ source: "standard", suiteCategory: x[0] })
                : F.pipe(
                      O.fromNullable(longSource[x[0]]),
                      O.map((source) => ({ source, suiteCategory: x[1] })),
                  ),
        ),
    )
